import { memo } from "react";
import { useTranslation } from "react-i18next";
import { Logo } from "../common/Logo";
import { StopFreeSaleExportTable } from "./StopFreeSaleExportTable";
import { enmStopFreeSale } from "../../models/enums/StopFreeSale";
import dayjs from "dayjs";
import { mdlStopFreeSaleExport } from "../../models/domain/StopFreeSaleExport";
import { mdlStopFreeSaleExportAgencyData } from "../../models/domain/StopFreeSaleExportAgencyData";
import { mdlStopFreeSaleDetail } from "../../models/domain/StopFreeSaleDetail";
import { mdlStopFreeSaleMessage } from "../../models/domain/StopFreeSaleMessage";
import _ from "lodash";
import { mdlUserInfo } from "../../models/domain/UserInfo";

export type AgencyEmailTemplateProps = {
    dataSource?: mdlStopFreeSaleExport;
    detail?: mdlStopFreeSaleDetail[];
    message?: mdlStopFreeSaleMessage;
    activeAgency?: mdlStopFreeSaleDetail;
    activeUser?:mdlUserInfo;
    stopFreeSaleType?: enmStopFreeSale;
}

export const AgencyEmailTemplate = memo(function AgencyEmailTemplate(props: AgencyEmailTemplateProps) {
    const { t } = useTranslation();
    const getDetail = () => {
        return props.activeAgency ? props.activeAgency : props.detail ? _.first(props.detail) : undefined;
    }
    const getHeaderText = () => {
        const hotelName:string = props.dataSource?.hotelName ?? "";
        let result:string = "";
        let message:string | undefined = undefined;
        if(props.message != undefined){
                message = props.stopFreeSaleType == enmStopFreeSale.StopSale ? props.message.stopMessage : props.message.freeMessage;
        }
        if(message){
            result = message.replace("@Hotel", hotelName);
            result = message.replace("@Type", props.stopFreeSaleType == enmStopFreeSale.StopSale ? t("stopFreeSale.create.stopSale") : t("stopFreeSale.create.freeSale"));
        }else{
            if(props.dataSource?.status == "Y"){
                result = t("stopFreeSaleExportTable.newMessage").replace("@Hotel", hotelName);
                result = result.replace("@Type", props.stopFreeSaleType == enmStopFreeSale.StopSale ? t("stopFreeSale.create.stopSale") : t("stopFreeSale.create.freeSale"));
        }else{
                result = t("stopFreeSaleExportTable.cancelMessage").replace("@Hotel", hotelName);
                result = result.replace("@Type", props.stopFreeSaleType == enmStopFreeSale.StopSale ? t("stopFreeSale.create.stopSale") : t("stopFreeSale.create.freeSale"));
            }
        }
        return result;
    }
    return (
        <>
            {
                props.dataSource
                &&
                <>
                    <div>
                        <div>
                            <table border={0} cellSpacing={0} cellPadding={0} style={{ width: "100%" }}>
                                <tr>
                                    <td style={{ padding: "10px" }}>
                                        <img src={`${process.env.REACT_APP_AMAZON_URI}hotel/${props.dataSource.hotelId}/Thumb/logo.png?ver=${Math.floor(Math.random() * parseFloat(dayjs().day.toString()))}`}></img>
                                    </td>
                                    <td style={{ textAlign: "right" }}>
                                        <span className="mt-2">{dayjs().format("DD.MM.YYYY HH:mm")}</span>
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div style={{ padding: "10px", fontFamily: "Helvetica, Arial, sans-serif", fontSize: "12px", color: "#787878", backgroundColor: "#f8f8f8", borderLeft: "1px solid #E1E1E1", borderRight: "1px solid #E1E1E1" }}>
                            <div>
                                <div style={{ lineHeight: "25px", color: "#F07800", fontFamily: "Tahoma, Geneva, sans-serif", fontSize: "24px", letterSpacing: "0px", marginBottom: "15px", marginTop: "2px" }}>
                                    <span> {props.stopFreeSaleType == enmStopFreeSale.StopSale ? t("stopSaleMailTemplate.newStopSale") : t("stopSaleMailTemplate.newFreeSale")} </span>
                                    <span> {getDetail()?.agencyName} </span>
                                    <span> {t("stopSaleMailTemplate.dearPartner")} </span>
                                </div>
                            </div>
                            <div style={{ padding: "10px 0"}}>
                                <p dangerouslySetInnerHTML={{ __html: getHeaderText() }} />
                            </div>
                            <div>
                                <table style={{ width: "100%", margin: "0 auto", fontFamily: "Verdana, Geneva, sans-serif", fontSize: "11px", padding: "10px", background: `#e8edff`, color: "#666" }} width="549" border={0} cellSpacing={0} cellPadding={0} id="dtSend">
                                    <tbody>
                                        <tr style={{ borderBottom: "1px solid #fff" }}>
                                            <td style={{ padding: "10px" }}><strong> {t("stopSaleMailTemplate.hotel")}</strong>
                                            </td>
                                            <td style={{ padding: "10px" }}>:</td>
                                            <td style={{ padding: "10px" }}>
                                                <strong> {props.dataSource.hotelName} </strong>
                                            </td>
                                        </tr>
                                        <tr style={{ borderBottom: "1px solid #fff" }}>
                                            <td style={{ padding: "10px" }}><strong>{t("stopSaleMailTemplate.market")}</strong></td>
                                            <td style={{ padding: "10px" }}>:</td>
                                            <td style={{ padding: "10px" }}>
                                                <strong> {getDetail()?.marketName} </strong>
                                            </td>
                                        </tr>
                                        <tr style={{ borderBottom: "1px solid #fff" }}>
                                            <td style={{ padding: "10px" }}>{t("stopSaleMailTemplate.agency")}</td>
                                            <td style={{ padding: "10px" }}>:</td>
                                            <td style={{ padding: "10px" }}>{getDetail()?.agencyName}</td>
                                        </tr>
                                        <tr style={{ borderBottom: "1px solid #fff" }}>
                                            <td style={{ padding: "10px" }}>{t("stopSaleMailTemplate.roomType")}</td>
                                            <td style={{ padding: "10px" }}>:</td>
                                            <td style={{ padding: "10px" }}>{getDetail()?.roomTypeName}</td>
                                        </tr>
                                        <tr style={{ borderBottom: "1px solid #fff" }}>
                                            <td style={{ padding: "10px" }}>{t("stopSaleMailTemplate.applicationType")}</td>
                                            <td style={{ padding: "10px" }}>:</td>
                                            <td style={{ padding: "10px" }}>{props.dataSource?.checkInStay == 0 ? t("stopSaleMailTemplate.stayed") : t("stopSaleMailTemplate.entered")}</td>
                                        </tr>
                                        <tr style={{ borderBottom: "1px solid #fff" }}>
                                            <td style={{ padding: "10px" }}>{t("stopSaleMailTemplate.boardType")}</td>
                                            <td style={{ padding: "10px" }}>:</td>
                                            <td style={{ padding: "10px" }}>{getDetail()?.boardName}</td>
                                        </tr>
                                        <tr style={{ borderBottom: "1px solid #fff" }}>
                                            <td style={{ padding: "10px" }}>{t("stopSaleMailTemplate.startDate")}</td>
                                            <td style={{ padding: "10px" }}>:</td>
                                            <td style={{ padding: "10px" }}>{dayjs(props.dataSource?.startDate).format("DD.MM.YYYY")}</td>
                                        </tr>
                                        <tr style={{ borderBottom: "1px solid #fff" }}>
                                            <td style={{ padding: "10px" }}>{t("stopSaleMailTemplate.endDate")}</td>
                                            <td style={{ padding: "10px" }}>:</td>
                                            <td style={{ padding: "10px" }}>{dayjs(props.dataSource?.endDate).format("DD.MM.YYYY")}</td>
                                        </tr>
                                        <tr style={{ borderBottom: "1px solid #fff" }}>
                                            <td style={{ padding: "10px" }}>{t("stopSaleMailTemplate.status")}</td>
                                            <td style={{ padding: "10px" }}>:</td>
                                            <td style={{ padding: "10px" }}>{props.dataSource?.status && props.dataSource?.status == "Y" ? t("stopFreeSaleTable.new") : t("stopFreeSaleTable.cancel") }</td>
                                        </tr>
                                        <tr style={{ borderBottom: "1px solid #fff" }}>
                                            <td style={{ padding: "10px" }}>{t("stopSaleMailTemplate.note")}</td>
                                            <td style={{ padding: "10px" }}>:</td>
                                            <td style={{ padding: "10px" }}>{props.dataSource?.note}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <h5 style={{padding: "10px"}}>{t("stopSaleMailTemplate.senderUser")} {`${props.activeUser?.firstName} ${props.activeUser?.lastName}`}</h5>
                            <div>
                                <table border={0} cellSpacing={0} cellPadding={0} style={{width: "100%"}}>
                                    <tr>
                                        <td style={{ padding: "10px" }}>
                                            <p dangerouslySetInnerHTML={{ __html: t("stopSaleMailTemplate.copyright") }} />
                                        </td>
                                        <td style={{ textAlign: "right" }}>
                                            <Logo />
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </>
            }
        </>
    )
})